/* -- Generated File: Do Not Edit ------------------------------------------ */
export const theme = {
  contextualBanner: {
    borderWidthContextualBannerRegular: '4px',
    borderColorContextualBannerRegular: 'rgba(128, 128, 128, 0.1)',
    borderColorContextualBannerSuccess: 'rgba(65, 185, 87, 0.1)',
    borderColorContextualBannerWarning: 'rgba(251, 164, 4, 0.1)',
    borderColorContextualBannerError: 'rgba(178, 7, 16, 0.1)',
    backgroundColorContextualBannerRegular: 'rgba(0, 0, 0, 0.04)',
    backgroundColorContextualBannerSuccess: 'rgba(65, 185, 87, 0.1)',
    backgroundColorContextualBannerWarning: 'rgba(251, 164, 4, 0.1)',
    backgroundColorContextualBannerError: 'rgba(178, 7, 16, 0.1)',
  },
  table: {
    backgroundColorCellSuccess: 'rgba(65, 185, 87, 0.1)',
    backgroundColorCellWarning: 'rgba(251, 164, 4, 0.1)',
    backgroundColorCellError: 'rgba(178, 7, 16, 0.1)',
  },
  body: {
    fontSize0: '13px',
    fontSize1: '14px',
    fontSize2: '16px',
    fontWeightRegular: '400',
    fontWeightBold: '600',
    lineHeightRegular: '1.5',
  },
  brand: {
    borderColorRegular: 'rgb(209, 21, 30)',
    borderColorAlpha: 'rgb(0, 0, 0)',
    fontFamilyRegular:
      '"Netflix Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontFamilyAlpha:
      '"Netflix Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontFamilyAlphalabel:
      '"Netflix Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontSizeRegular: '16px',
    fontSizeAlpha: '13px',
    fontSizeAlphalabel: '8px',
    lineHeightRegular: '18px',
    lineHeightAlpha: '14px',
    lineHeightAlphalabel: '10px',
    backgroundColorRegular: 'rgb(229, 9, 20)',
    textColorAlphalabel: 'rgb(209, 21, 30)',
  },
  colors: {
    gray0: 'rgb(128, 128, 128)',
    gray1: 'rgb(142, 142, 142)',
    gray2: 'rgb(155, 155, 155)',
    gray3: 'rgb(169, 169, 169)',
    gray4: 'rgb(182, 182, 182)',
    gray5: 'rgb(196, 196, 196)',
    gray6: 'rgb(214, 214, 214)',
    gray7: 'rgb(229, 229, 229)',
    gray8: 'rgb(242, 242, 242)',
    gray9: 'rgb(250, 250, 250)',
    grayBase: 'rgb(128, 128, 128)',
    grayT70: 'rgba(128, 128, 128, 0.7)',
    grayT40: 'rgba(128, 128, 128, 0.4)',
    grayT20: 'rgba(128, 128, 128, 0.2)',
    grayT10: 'rgba(128, 128, 128, 0.1)',
    accessibleRedBase: 'rgb(178, 7, 16)',
    accessibleRedT70: 'rgba(178, 7, 16, 0.7)',
    accessibleRedT40: 'rgba(178, 7, 16, 0.4)',
    accessibleRedT20: 'rgba(178, 7, 16, 0.2)',
    accessibleRedT10: 'rgba(178, 7, 16, 0.1)',
  },
  destructive: {
    backgroundColorRegular: 'rgb(178, 7, 16)',
    backgroundColorHover: 'rgb(127, 5, 11)',
    backgroundColorDisabled: 'rgba(178, 7, 16, 0.4)',
  },
  elevation: {
    borderWidthFlat: '0px',
    borderWidthElevated: '0px',
    borderColorFlat: 'rgba(0, 0, 0, 0)',
    borderColorElevated: 'rgba(0, 0, 0, 0)',
    boxShadow0: '0 1px 2px 0 rgba(0,0,0,0), 0 0 2px 0 rgba(0,0,0,0.10)',
    boxShadow1: '0 2px 4px 0 rgba(0,0,0,0.10), 0 0 2px 0 rgba(0,0,0,0.10)',
    boxShadow2: '0 4px 8px 0 rgba(0,0,0,0.10), 0 0 2px 0 rgba(0,0,0,0.10)',
    backgroundColor0: 'rgb(255, 255, 255)',
    backgroundColor1: 'rgb(255, 255, 255)',
    backgroundColor2: 'rgb(255, 255, 255)',
    backgroundColor3: 'rgb(255, 255, 255)',
  },
  focus: {
    borderWidthRegular: '2px',
    borderColorRegular: 'rgb(73, 105, 228)',
    borderColorReversed: 'rgb(73, 105, 228)',
  },
  heading: {
    fontSize0: '18px',
    fontSize1: '20px',
    fontSize2: '24px',
    fontSize3: '28px',
    fontSize4: '32px',
    fontSize5: '40px',
    fontSize6: '52px',
    fontSize7: '68px',
    fontSize8: '88px',
    fontWeightRegular: '700',
    fontWeightBold: '800',
    lineHeightRegular: '1.25',
  },
  highlight: { backgroundColorRegular: 'rgba(0, 0, 0, 0.02)' },
  icon: {
    fillRegular: 'rgba(0, 0, 0, 0.9)',
    fillLight: 'rgba(0, 0, 0, 0.6)',
    fillXlight: 'rgba(0, 0, 0, 0.4)',
    fillReverseRegular: 'rgba(255, 255, 255, 0.9)',
    fillReverseLight: 'rgba(255, 255, 255, 0.6)',
    fillReverseXlight: 'rgba(255, 255, 255, 0.4)',
    fillInformationSuccess: 'rgb(36, 103, 48)',
    fillInformationWarning: 'rgb(139, 91, 2)',
    fillInformationError: 'rgb(178, 7, 16)',
    fillInteractiveRegular: 'rgb(57, 82, 177)',
    fillInteractiveLight: 'rgba(57, 82, 177, 0.6)',
    fillInteractiveXlight: 'rgba(57, 82, 177, 0.4)',
  },
  information: {
    borderWidthRegular: '1px',
    borderColorSuccess: 'rgb(65, 185, 87)',
    borderColorWarning: 'rgb(251, 164, 4)',
    borderColorError: 'rgb(178, 7, 16)',
    backgroundColorRegular: 'rgb(103, 103, 103)',
    backgroundColorSuccess: 'rgb(65, 185, 87)',
    backgroundColorWarning: 'rgb(251, 164, 4)',
    backgroundColorError: 'rgb(178, 7, 16)',
  },
  interactive: {
    backgroundColorRegular: 'rgb(73, 105, 228)',
    backgroundColorHover: 'rgb(57, 82, 177)',
    backgroundColorActive: 'rgb(41, 58, 127)',
    backgroundColorDisabled: 'rgba(73, 105, 228, 0.4)',
    backgroundColorBrandRegular: 'rgb(229, 9, 20)',
    backgroundColorBrandHover: 'rgb(178, 7, 16)',
    backgroundColorBrandActive: 'rgb(127, 5, 11)',
    backgroundColorBrandDisabled: 'rgba(229, 9, 20, 0.4)',
  },
  label: {
    fontSize0: '10px',
    fontSize1: '12px',
    fontWeightRegular: '400',
    fontWeightBold: '600',
    lineHeightRegular: '1.5',
  },
  lifecycle: {
    borderWidthRegular: '1px',
    borderColorUnknown: 'rgb(103, 103, 103)',
    borderColorPitch: 'rgb(139, 91, 2)',
    borderColorOption: 'rgb(191, 86, 15)',
    borderColorTentative: 'rgb(166, 47, 89)',
    borderColorDevelopment: 'rgb(137, 58, 156)',
    borderColorPreproduction: 'rgb(113, 75, 226)',
    borderColorProduction: 'rgb(24, 102, 170)',
    borderColorPostproduction: 'rgb(28, 95, 105)',
    borderColorLaunchprep: 'rgb(36, 103, 48)',
    borderColorLaunched: 'rgb(22, 62, 29)',
    borderColorDead: 'rgb(178, 7, 16)',
    backgroundColorUnknown: 'rgb(103, 103, 103)',
    backgroundColorPitch: 'rgb(139, 91, 2)',
    backgroundColorOption: 'rgb(191, 86, 15)',
    backgroundColorTentative: 'rgb(166, 47, 89)',
    backgroundColorDevelopment: 'rgb(137, 58, 156)',
    backgroundColorPreproduction: 'rgb(113, 75, 226)',
    backgroundColorProduction: 'rgb(24, 102, 170)',
    backgroundColorPostproduction: 'rgb(28, 95, 105)',
    backgroundColorLaunchprep: 'rgb(36, 103, 48)',
    backgroundColorLaunched: 'rgb(22, 62, 29)',
    backgroundColorDead: 'rgb(178, 7, 16)',
  },
  overlay: { backgroundColorRegular: 'rgba(0, 0, 0, 0.7)' },
  persistent: {
    backgroundColorWhiteRegular: 'rgb(255, 255, 255)',
    backgroundColorWhiteLight: 'rgba(255, 255, 255, 0.7)',
    backgroundColorWhiteXlight: 'rgba(255, 255, 255, 0.4)',
    backgroundColorBlackRegular: 'rgb(0, 0, 0)',
    backgroundColorBlackLight: 'rgba(0, 0, 0, 0.7)',
    backgroundColorBlackXlight: 'rgba(0, 0, 0, 0.4)',
    textColorWhiteRegular: 'rgb(255, 255, 255)',
    textColorWhiteLight: 'rgba(255, 255, 255, 0.6)',
    textColorWhiteXlight: 'rgba(255, 255, 255, 0.4)',
    textColorBlackRegular: 'rgba(0, 0, 0, 0.9)',
    textColorBlackLight: 'rgba(0, 0, 0, 0.6)',
    textColorBlackXlight: 'rgba(0, 0, 0, 0.4)',
    iconFillWhiteRegular: 'rgb(255, 255, 255)',
    iconFillWhiteLight: 'rgba(255, 255, 255, 0.6)',
    iconFillWhiteXlight: 'rgba(255, 255, 255, 0.4)',
    iconFillBlackRegular: 'rgba(0, 0, 0, 0.9)',
    iconFillBlackLight: 'rgba(0, 0, 0, 0.6)',
    iconFillBlackXlight: 'rgba(0, 0, 0, 0.4)',
  },
  state: {
    backgroundColorHover: 'rgba(0, 0, 0, 0.04)',
    backgroundColorSelected: 'rgba(73, 105, 228, 0.2)',
    backgroundColorSelectedHover: 'rgba(73, 105, 228, 0.4)',
    backgroundColorHighlightRegular: 'rgb(229, 9, 20)',
    backgroundColorHighlightLight: 'rgba(229, 9, 20, 0.7)',
    backgroundColorHighlightXlight: 'rgba(229, 9, 20, 0.4)',
  },
  textColor: {
    textColorRegular: 'rgba(0, 0, 0, 0.9)',
    textColorLight: 'rgba(0, 0, 0, 0.6)',
    textColorXlight: 'rgba(0, 0, 0, 0.4)',
    textColorReverseRegular: 'rgb(255, 255, 255)',
    textColorReverseLight: 'rgba(255, 255, 255, 0.6)',
    textColorReverseXlight: 'rgba(255, 255, 255, 0.4)',
    textColorHeadingRegular: 'rgba(0, 0, 0, 0.9)',
    textColorHeadingLight: 'rgba(0, 0, 0, 0.6)',
    textColorHeadingXlight: 'rgba(0, 0, 0, 0.4)',
    textColorHeadingReverseRegular: 'rgb(255, 255, 255)',
    textColorHeadingReverseLight: 'rgba(255, 255, 255, 0.6)',
    textColorHeadingReverseXlight: 'rgba(255, 255, 255, 0.4)',
    textColorInformationError: 'rgb(178, 7, 16)',
    textColorInformationSuccess: 'rgb(36, 103, 48)',
    textColorInformationWarning: 'rgb(139, 91, 2)',
    textColorInteractiveRegular: 'rgb(57, 82, 177)',
    textColorInteractiveLight: 'rgba(57, 82, 177, 0.6)',
    textColorInteractiveXlight: 'rgba(57, 82, 177, 0.4)',
  },
  ui: {
    borderWidthRegular: '1px',
    borderColorRegular: 'rgb(128, 128, 128)',
    borderColorLight: 'rgba(128, 128, 128, 0.4)',
    borderColorXlight: 'rgba(128, 128, 128, 0.2)',
    borderColorReverseRegular: 'rgb(255, 255, 255)',
    borderColorReverseLight: 'rgba(255, 255, 255, 0.4)',
    borderColorReverseXlight: 'rgba(255, 255, 255, 0.2)',
    backgroundColor0: 'rgb(255, 255, 255)',
    backgroundColor1: 'rgb(250, 250, 250)',
    backgroundColor2: 'rgb(242, 242, 242)',
    backgroundColor3: 'rgb(229, 229, 229)',
    backgroundColor4: 'rgb(182, 182, 182)',
    backgroundColor5: 'rgb(103, 103, 103)',
    backgroundColor6: 'rgb(15, 15, 15)',
  },
  validation: { backgroundColorError: 'rgba(178, 7, 16, 0.1)' },
};

export default {
  theme,
};
/* -- Generated File: Do Not Edit ------------------------------------------ */
